import { PaymentService } from "../../services/PaymentService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const usePaymentsApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const paymentService = new PaymentService(appConfig.apiBaseUrl);

    const findAllPayments = async (propertyId, reservationId) => {
        return executeApiOperation(() => paymentService.findAll(propertyId, reservationId));
    };

    const createPayment = async (propertyId, payment) => {
        return executeApiOperation(() => paymentService.create(propertyId, payment));
    };

    const updatePayment = async (propertyId, payment) => {
        return executeApiOperation(() => paymentService.update(propertyId, payment));
    };

    const deletePayment = async (propertyId, paymentId) => {
        return executeApiOperation(() => paymentService.delete(propertyId, paymentId));
    };

    return {
        findAllPayments,
        createPayment,
        updatePayment,
        deletePayment,
    };
};